"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MallocErrorTypes = void 0;
var MallocErrorTypes;
(function (MallocErrorTypes) {
    // Corresponds to a an error building the general construction
    MallocErrorTypes["MALLOC_BUILDER"] = "Malloc Builder";
    // Corresponds to an error building a specific action in the construction
    MallocErrorTypes["MALLOC_ACTION_BUILDER"] = "Malloc Action Builder";
    // Corresponds to an error in compiling a built action
    MallocErrorTypes["MALLOC_COMPILER"] = "Malloc Compiler";
    // Corresponds to an error which occurred during runtime.
    MallocErrorTypes["MALLOC_RUNNER"] = "Malloc Runner";
})(MallocErrorTypes = exports.MallocErrorTypes || (exports.MallocErrorTypes = {}));
